import Book from 'models/book'
import React from 'react'

interface IStoryContext {
  currentStory: Book
}

export const StoryContext = React.createContext<IStoryContext>({
  currentStory: null,
})
